import { render, staticRenderFns } from "./KnowledgeAnalysis.vue?vue&type=template&id=17239ce0&scoped=true"
import script from "./KnowledgeAnalysis.vue?vue&type=script&lang=js"
export * from "./KnowledgeAnalysis.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeAnalysis.vue?vue&type=style&index=0&id=17239ce0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17239ce0",
  null
  
)

export default component.exports